import { computed } from 'vue';
import { useStore } from 'vuex';
import _ from 'lodash-es';
import { Tenant } from '@/app/data/model_constants';
import useEmailValidation from '@/app/util/use_email_validation';

export default function useContactEmail() {
  const store = useStore();
  const { isEmailUnique } = useEmailValidation();

  const current_client = computed(() => store.getters.current_client);

  const email_address_suffix = computed(() =>
    current_client.value.attributes.status === Tenant.STATUS_DEMO
      ? `@${current_client.value.attributes.subdomain}.ziggu.app`
      : '',
  );

  function emailAddressDemo(email_address) {
    return (
      !email_address ||
      current_client.value.attributes.status !== Tenant.STATUS_DEMO ||
      email_address.trim().endsWith(email_address_suffix.value) ||
      email_address.trim().endsWith('@ziggu.io')
    );
  }

  function createDebouncedEmailHandler(vuelidate_path, record_ref) {
    return _.debounce((e) => {
      vuelidate_path().email_address.$model = e.target.value.toLowerCase();
      record_ref.value.attributes.email_address = vuelidate_path().email_address.$model;
    }, 500);
  }

  return {
    email_address_suffix,
    emailAddressDemo,
    isEmailUnique,
    createDebouncedEmailHandler,
  };
}
